import angular from 'angular'
import operation from './operation'

export default angular.module('system.log', [operation])
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider.state('system.log', {
            abstract: true,
            url: '/log',
            template: '<div ui-view></div>',
            title: '日志管理',
        })
    }]).name



// WEBPACK FOOTER //
// ./src/app/system/log/index.js